/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { AnalyticsResultFormatterMessage } from "../../../messages/analytics-result-formatter.message";

const formatNumber = (number: number) => {
  return new Intl.NumberFormat("en-GB", {
    notation: "compact",
    compactDisplay: "short",
    minimumFractionDigits: 0,
  }).format(number);
};

export const triggerConsumedGrantSum = (lifeCycle: any) => {
  const message = lifeCycle?.fsm?.message as AnalyticsResultFormatterMessage;
  const template = message?.template?.layout[0]?.colProps;
  const found = template?.find((o: any) => o.key === "consumedGrant");
  if (found?.compProps?.appCardList && found?.compProps?.appCardList[0]) {
    found.compProps.appCardList[0].value = 
      Array.isArray(message?.raw?.discountStats) && formatNumber(message?.raw?.discountStats[0]?.consumedGrant);
  }
  return true;
};
